export default __webpack_public_path__ + "static/media/manage-business.24ac3d14.png";